<div class="row m-3">
  <div class="col-xs-12 col-sm-12 col-md-6 mx-auto">
    <div class="card">
      <div class="card-header">
        Zertifikat ansehen
      </div>

      <div class="card-body" *ngIf="certificateDetails">
        <div class="row mb-3">
          <div class="control-label col-form-label col-5">ID</div>
          <div class="col-7">
            <p class="form-control">
              {{ certificateDetails.certificate.id }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Seriennummer (dez/hex)</div>
          <div class="col-7">
            <p class="form-control">
              {{ certificateDetails.certificate.serialNumber }} / {{ certificateDetails.certificate.serialNumberInHex }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Antragssteller</div>
          <div class="col-7">
            <p class="form-control">
              {{ certificateDetails.certificate.subjectX500Principal| principalName: false }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Aussteller</div>
          <div class="col-7">
            <a *ngIf="issuerCertificateID" [routerLink]="['/schluessel/zertifikate', issuerCertificateID]">
              {{ certificateDetails.certificate.issuerX500Principal| principalName: false }}
            </a>
            <p *ngIf="!issuerCertificateID" class="form-control">
              {{ certificateDetails.certificate.issuerX500Principal| principalName: false }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Gültig von</div>
          <div class="col-7">
            <p class="form-control">
              {{ certificateDetails.certificate.validFrom }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Gültig bis</div>
          <div class="col-7">
            <p class="form-control">
              {{ certificateDetails.certificate.validTo }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Schlüssellänge</div>
          <div class="col-7">
            <p class="form-control">
              {{ certificateDetails.keyLength }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Fingerabdruck (SHA1)</div>
          <div class="col-7">
            <p class="form-control">
              {{ certificateDetails.thumbprintWithSHA1 }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Schlüsselverwendungen</div>
          <div class="col-7">
            <p class="form-control word-break-word">
              {{ certificateDetails.keyUsages }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Erweiterte Schlüsselverwendungen</div>
          <div class="col-7">
            <p class="form-control word-break-word">
              {{ certificateDetails.extendedKeyUsages }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="offset-5 col-7">
            <button class="btn btn-primary" (click)="downloadFile($event)" type="button">Download</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
